module.exports = __webpack_public_path__ + "static/media/desk.a209611f.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/desk.png
// module id = 349
// module chunks = 0